//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportEventCategoryIDsInputItem } from './IReportEventCategoryIDsInputItem';
import { IReportEventLocationIDsInputItem } from './IReportEventLocationIDsInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { IReportTeacherIDsInputItem } from './IReportTeacherIDsInputItem';
import { CalendarReportGroupBy, ReportType } from './Enums';

export class CalendarMonthReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportEventCategoryIDsInputItem, IReportEventLocationIDsInputItem, IReportStudentIDsInputItem, IReportTeacherIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    EventCategoryIDs: string[] = [];
    EventLocationIDs: string[] = [];
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    HideEmptyEvents: boolean = false;
    HideFullEvents: boolean = false;
    GroupBy: CalendarReportGroupBy = CalendarReportGroupBy.EventLocation;
    override readonly Type: ReportType = ReportType.Calendar;
    StudentFirstNameOnly: boolean = false;

    constructor(initializer?: Partial<Omit<CalendarMonthReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CalendarMonthReportInputItem";
}
